import { SUPPORT_EMAIL } from "./brand";

export const OFFICE_ADDRESS =
  "P 155/A Gali, Plot No. Q 52, S/F, KH No. 18/8, Gali No. 5, Phase-4, Shiv Vihar, Karawal Nagar, Near Rathor Dharamshala, Delhi – 110094";

export const CONTACT_PHONES = [
  { tel: "+918796814100", label: "+91 8796814100" },
  { tel: "+918796824100", label: "+91 8796824100" },
];

export const CONTACT_EMAIL = SUPPORT_EMAIL;

export const CONTACT_EMAILS = [
  { email: SUPPORT_EMAIL, label: SUPPORT_EMAIL },
  { email: "admin@ssdi.co.in", label: "admin@ssdi.co.in" },
];

export const SUPPORT_MAILTO_HREF = `mailto:${CONTACT_EMAIL}`;
export const SUPPORT_GMAIL_COMPOSE_HREF = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(CONTACT_EMAIL)}`;

export function openSupportMail(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const mobile =
    typeof navigator !== "undefined" && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);

  if (mobile) {
    window.location.href = SUPPORT_MAILTO_HREF;
    return;
  }

  const popup = window.open(SUPPORT_GMAIL_COMPOSE_HREF, "_blank", "noopener,noreferrer");
  if (!popup) {
    window.location.href = SUPPORT_MAILTO_HREF;
  }
}

export const SSDI_WEBSITE_LABEL = "www.ssdi.co.in";
export const SSDI_WEBSITE_URL = "https://www.ssdi.co.in/";
